// NIGHT-DIRECTSTAFF-2026-10-23b §2: "Possible duplicate" on a candidate -- the other candidate records with the same phone or
// email. Open goes to it; Merge (once the hub applies candidates.merged_into) keeps the OLDER record, asks first, and the
// database moves the newer one's activity, placements, documents, drafts, messages and offers to it. Nothing is deleted.
// lib/candidateDupes.js holds the rules.
import React, { useState } from 'react';
import { possibleDuplicates, olderNewer } from './lib/candidateDupes';

const btn = (bg, fg, off) => ({ background: bg, color: fg, borderRadius: 8, padding: '0 14px', minHeight: 44, fontSize: 13, fontWeight: 700, border: 0,
  cursor: off ? 'not-allowed' : 'pointer', opacity: off ? 0.5 : 1 });
const name = (c) => c.name || 'No name';

/** candidate; candidates: the not-merged list; canMerge: the columns exist; merge(keepId, otherId) -> throws plain words; onOpen(c); toast */
export default function CandidateDuplicates({ candidate, candidates, canMerge = false, merge, onOpen = () => {}, toast = () => {} }) {
  const [asking, setAsking] = useState(null);
  const [busy, setBusy] = useState(false);
  const [refused, setRefused] = useState('');
  const dups = possibleDuplicates(candidate, candidates);
  if (!dups.length) return null;
  const go = async (keep, other) => {
    setBusy(true); setRefused('');
    try { await merge(keep.id, other.id); setAsking(null); toast(`Merged: #${other.id} is now part of #${keep.id}`); }
    catch (e) { setRefused(e.message || 'Could not merge'); } finally { setBusy(false); }
  };
  return (
    <div data-testid="cand-dups" role="note" style={{ marginTop: 10, padding: '10px 12px', background: '#fffbeb', border: '1px solid #fcd34d', borderRadius: 10, fontSize: 13, color: '#713f12' }}>
      {dups.map(({ other, on }) => { const { older, newer } = olderNewer(candidate, other); const pair = asking === other.id; return (
        <div key={other.id} data-testid={`cand-dup-${other.id}`} style={{ display: 'grid', gap: 6 }}>
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'center' }}>
            <b>Possible duplicate:</b>
            <span style={{ overflowWrap: 'anywhere', minWidth: 0 }}>#{other.id} {name(other)} (same {on})</span>
            <button className="nb" data-testid={`cand-dup-open-${other.id}`} onClick={() => onOpen(other)} style={btn('#f1f5f9', '#1d4ed8')}>Open #{other.id}</button>
            {canMerge ? !pair && <button className="nb" data-testid={`cand-dup-merge-${other.id}`} onClick={() => { setAsking(other.id); setRefused(''); }} style={btn('#92400e', 'white')}>Merge…</button>
              : <span data-testid="cand-dup-dark" style={{ fontSize: 12, color: '#475569' }}>Merge turns on when the hub applies 2026-10-23-candidates-merged-into.sql.</span>}
          </div>
          {pair && (
            <div data-testid={`cand-dup-ask-${other.id}`} style={{ display: 'grid', gap: 6, paddingTop: 4 }}>
              <p style={{ margin: 0, color: '#0f172a' }}>
                Keep <b>#{older.id}</b> (the older record) and merge <b>#{newer.id}</b> into it? Its activity, placements, documents, drafts and offers move to #{older.id};
                #{newer.id} is hidden from the lists and never deleted. The CRM cannot undo this (the hub can).
              </p>
              <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                <button className="nb" data-testid={`cand-dup-confirm-${other.id}`} disabled={busy} onClick={() => go(older, newer)} style={btn('#92400e', 'white', busy)}>{busy ? 'Merging…' : `Merge #${newer.id} into #${older.id}`}</button>
                <button className="nb" data-testid={`cand-dup-cancel-${other.id}`} disabled={busy} onClick={() => { setAsking(null); setRefused(''); }} style={btn('#f1f5f9', '#334155', busy)}>Cancel</button>
              </div>
              {refused && <p data-testid={`cand-dup-refused-${other.id}`} role="alert" style={{ margin: 0, color: '#991b1b', fontWeight: 600 }}>{refused}</p>}
            </div>)}
        </div>); })}
    </div>
  );
}
